import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Grid, Tooltip } from "@mui/material";
import { Icon } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const LockDeviationIcon: React.FC = () => {
  return (
    <Tooltip
      placement="top"
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.LockTooltipText)}
      arrow
      classes={{
        tooltip: cssExports.tooltip,
        popper: cssExports.tooltipPopper,
        arrow: cssExports.tooltipArrow,
      }}
    >
      <Grid item>
        <Icon icon={IconDefinitionConstants.WLock} className={cssExports.listDragIcon} />
      </Grid>
    </Tooltip>
  );
};

export default LockDeviationIcon;
